// Navigace je dvouúrovňová (dle designu): skupiny s podmoduly se dají
// sbalit/rozbalit, `countKey` plní číslo z /api/dashboard/summary.
export const NAV = [
  { key: "home", label: "Domů", path: "/", icon: "Home", roles: null },
  { key: "calendar", label: "Úkoly", path: "/ukoly", icon: "ListChecks", roles: null },
  {
    key: "obchod", label: "Obchod", icon: "Briefcase", roles: null,
    children: [
      // Pořadí: klienti → obchodní případy → nabídky → obchodní partneři.
      { key: "klienti", label: "Klienti", path: "/klienti", icon: "Users", roles: null, countKey: "pocet_klientu" },
      // Stejné role jako route guard v App.js — dřív měl subdodavatel položku
      // v menu, ale stránka ho přesměrovala domů.
      { key: "pripady", label: "Obchodní případy", path: "/obchod", icon: "Briefcase", roles: ["OWNER", "OBCHODNIK", "TECHNIK", "ASISTENTKA", "SUBDODAVATEL"], countKey: "pocet_pripadu" },
      { key: "nabidky", label: "Nabídky", path: "/nabidky", icon: "FileText", roles: ["OWNER", "OBCHODNIK", "SUBDODAVATEL"] },
      // Kdo nám dohazuje klienty — stejné role jako backend (routes/partneri.py).
      { key: "partneri", label: "Obchodní partneři", path: "/partneri", icon: "Handshake", roles: ["OWNER", "OBCHODNIK", "ASISTENTKA"] },
    ],
  },
  {
    // Asistentka do skupiny patří kvůli skladu — přehled ani doklady jí backend nevrátí,
    // takže se jí skupina zobrazí jako plochá položka „Sklad".
    key: "ekonomika", label: "Ekonomika", icon: "LineChart", roles: ["OWNER", "OBCHODNIK", "ASISTENTKA"],
    children: [
      { key: "ekonomika-prehled", label: "Přehled", path: "/ekonomika", icon: "LineChart", roles: ["OWNER", "OBCHODNIK"] },
      { key: "kpi", label: "KPI", path: "/kpi", icon: "BarChart3", roles: ["OWNER", "OBCHODNIK"] },
      { key: "doklady", label: "Doklady", path: "/doklady", icon: "ReceiptText", roles: ["OWNER", "OBCHODNIK"], countKey: "pocet_dokladu_po_splatnosti" },
      { key: "sklad", label: "Sklad", path: "/sklad", icon: "Boxes", roles: ["OWNER", "OBCHODNIK", "ASISTENTKA"] },
    ],
  },
  { key: "polozky", label: "Ceník", path: "/polozky", icon: "Package", roles: ["OWNER", "OBCHODNIK"] },
  { key: "servis", label: "Servis", path: "/servis", icon: "Wrench",
    roles: ["OWNER", "OBCHODNIK", "TECHNIK", "ASISTENTKA", "SUBDODAVATEL"] },
  { key: "tym", label: "Tým", path: "/tym", icon: "UserCog",
    roles: ["OWNER", "OBCHODNIK", "TECHNIK", "ASISTENTKA"] },
];

// Subdodavatel je host jiné firmy: klienti ve svém rozsahu, kalendář a servis.
// S rozsahem OBCHOD navíc případy a nabídky svých klientů (bez nákupních cen).
// Ekonomika ani ceník mu backend stejně nevrátí — ať je ani nevidí.
const SUBDODAVATEL_MODULY = ["home", "calendar", "klienti", "servis"];
const SUBDODAVATEL_OBCHOD = ["pripady", "nabidky"];

export const jeSubdodavatel = (user) => (user?.roles || []).includes("SUBDODAVATEL") && !user?.superadmin;
export const subObchod = (user) => jeSubdodavatel(user) && user?.rozsah_sub === "OBCHOD";

/** Skupina je vidět, pokud ji smí vidět uživatel a má aspoň jedno viditelné dítě. */
export function visibleNav(user, canSeeFn) {
  const sub = jeSubdodavatel(user);
  const povoleno = (key) => !sub || SUBDODAVATEL_MODULY.includes(key) || (subObchod(user) && SUBDODAVATEL_OBCHOD.includes(key));
  return NAV.filter((i) => canSeeFn(user, i.roles)).map((i) => {
    if (!i.children) return povoleno(i.key) ? i : null;
    const children = i.children.filter((c) => canSeeFn(user, c.roles) && povoleno(c.key));
    if (!children.length) return null;
    // Skupina s jediným viditelným modulem se zobrazí jako plochá položka (bez obalu).
    if (children.length === 1) return { ...children[0] };
    return { ...i, children };
  }).filter(Boolean);
}

export const ROLE_LABEL = {
  OWNER: "Majitel",
  OBCHODNIK: "Obchodník",
  TECHNIK: "Technik",
  ASISTENTKA: "Asistentka",
  SUBDODAVATEL: "Subdodavatel",
};

export function canSee(user, roles) {
  if (!roles) return true;
  if (!user) return false;
  if (user.superadmin) return true;
  return (user.roles || []).some((r) => roles.includes(r));
}

export function canEditAktivita(user, oblast) {
  if (!user) return false;
  if (user.superadmin || (user.roles || []).includes("OWNER")) return true;
  const role = user.roles || [];
  if (oblast === "OBCHOD") return role.includes("OBCHODNIK") || role.includes("ASISTENTKA");
  if (oblast === "SERVIS")
    return ["TECHNIK", "ASISTENTKA", "SUBDODAVATEL"].some((r) => role.includes(r));
  return false;
}

export function czDate(d = new Date()) {
  return new Intl.DateTimeFormat("cs-CZ", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(d);
}

export function greeting() {
  const h = new Date().getHours();
  if (h < 10) return "Dobré ráno";
  if (h < 18) return "Dobrý den";
  return "Dobrý večer";
}
